import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';

export function getShouldHideInsertButton(viewState: FilePickerPanelViewState): boolean {
    switch (viewState.selectedFileProvider?.model.Type) {
        case AttachmentDataProviderType.OneDrivePro:
        case AttachmentDataProviderType.GDrive:
        case AttachmentDataProviderType.Dropbox:
        case AttachmentDataProviderType.Box:
            return false;
        case AttachmentDataProviderType.OneDriveConsumer:
            return !isConsumer();
        default:
            return true;
    }
}
